import Colors from "../Colors";

const baseWeapon = {
  displayPriority: 10,
  glyph: {
    fg: Colors.B_GREY_4,
    ch: "%",
  },
};

export const weapons = {
  needle: {
    ...baseWeapon,
    text: {
      name: "Large Steel Sowing Needle",
      info: "Swift and deadly, but offers no poise damage",
      description:
        "The chipping paint was once used to conceal the item's material. Far deadlier than a permitted wooden needle.",
      logName: "Needle",
    },
    stats: {
      weight: 1,
    },
    attacks: {
      onehanded: {
        strength: 1,
        stamina: 10,
        poise: 0,
        damage: 18,
      },
      twohanded: {
        strength: 1,
        stamina: 20,
        poise: 4,
        damage: 18,
      },
    },
  },
  shears: {
    ...baseWeapon,
    text: {
      name: "Halfshears",
      info:
        "A strong slash, but the crude craftsmanship makes it clumsy to wield",
      description:
        "One half of a hand shear, rusted over then crudely sharpened. A favorite of brigands who could arm two by splitting the shears.",
      logName: "Halfshears",
    },
    stats: {
      weight: 2,
    },
    attacks: {
      onehanded: {
        strength: 2,
        stamina: 30,
        poise: 10,
        damage: 17,
      },
      twohanded: {
        strength: 1,
        stamina: 20,
        poise: 10,
        damage: 17,
      },
    },
  },
  knife: {
    ...baseWeapon,
    text: {
      name: "Kitchen knife",
      info: "Well balanced and serviceable weapon",
      description:
        "A long kitchen knife. Blacksmiths supplying these knives undergo strict watch by the church's guards to comply with size limits.",
      logName: "Knife",
    },
    stats: {
      weight: 4,
    },
    attacks: {
      onehanded: {
        strength: 3,
        stamina: 25,
        poise: 10,
        damage: 22,
      },
      twohanded: {
        strength: 1,
        stamina: 25,
        poise: 15,
        damage: 22,
      },
    },
  },
  cleaver: {
    ...baseWeapon,
    text: {
      name: "Butcher's Cleaver",
      info: "Hard hitting and versitile, but requires a lot of stamina.",
      description:
        'Despite strict licensing ineveitably butcher cleaver\'s go "missing" and wind up in the wrong hands.',
      logName: "Cleaver",
    },
    stats: {
      weight: 5,
    },
    attacks: {
      onehanded: {
        strength: 4,
        stamina: 30,
        poise: 20,
        damage: 26,
      },
      twohanded: {
        strength: 2,
        stamina: 30,
        poise: 20,
        damage: 32,
      },
    },
  },
  spade: {
    ...baseWeapon,
    text: {
      name: "Digging Spade",
      info: "A decent punch, but unwieldy and heavy",
      description:
        "Garden tools are a common choice for a weapon when one has no other choice.",
      logName: "Spade",
    },
    stats: {
      weight: 7,
    },
    attacks: {
      onehanded: {
        strength: 1,
        stamina: 30,
        poise: 15,
        damage: 14,
      },
      twohanded: {
        strength: 1,
        stamina: 30,
        poise: 20,
        damage: 20,
      },
    },
  },
  mallet: {
    ...baseWeapon,
    text: {
      name: "Wooden Mallet",
      info: "A good swing that can stagger enemies easily.",
      description:
        "Common among carpenters, these mallets are easy to find and difficult to control the supply of.",
      logName: "Mallet",
    },
    stats: {
      weight: 4,
    },
    attacks: {
      onehanded: {
        strength: 2,
        stamina: 25,
        poise: 25,
        damage: 16,
      },
      twohanded: {
        strength: 1,
        stamina: 25,
        poise: 25,
        damage: 16,
      },
    },
  },
  flail: {
    ...baseWeapon,
    text: {
      name: "Threshing Flail",
      info: "A heavy strong blow that can rival metal weapons",
      description:
        "Commonly used the thresh wheat, these tools are deadly when swung with a good strong blow",
      logName: "Flail",
    },
    stats: {
      weight: 8,
    },
    attacks: {
      onehanded: {
        strength: 4,
        stamina: 40,
        poise: 30,
        damage: 28,
      },
      twohanded: {
        strength: 2,
        stamina: 40,
        poise: 30,
        damage: 28,
      },
    },
  },
  staff: {
    ...baseWeapon,
    text: {
      name: "Wooden Staff",
      info: "Quick to strike and easy to stagger a foe.",
      description:
        "Often concealed as a walking stick, when carried it's important to know which guard will give you trouble over its length.",
      logName: "Staff",
    },
    stats: {
      weight: 8,
    },
    attacks: {
      onehanded: {
        strength: 6,
        stamina: 25,
        poise: 30,
        damage: 26,
      },
      twohanded: {
        strength: 3,
        stamina: 25,
        poise: 30,
        damage: 26,
      },
    },
  },
  pitchfork: {
    ...baseWeapon,
    text: {
      name: "Three Pronged Pitchfork",
      info: "High stabbing damage, but not as much impact in the strike.",
      description:
        "Symbology of the pitchfork is banned after the three pronged rebellion of 712cs, but the tool itself is still permitted for farming.",
      logName: "Pitchfork",
    },
    stats: {
      weight: 10,
    },
    attacks: {
      onehanded: {
        strength: 6,
        stamina: 30,
        poise: 15,
        damage: 44,
      },
      twohanded: {
        strength: 3,
        stamina: 30,
        poise: 15,
        damage: 44,
      },
    },
  },
  scythe: {
    ...baseWeapon,
    text: {
      name: "Scythe",
      info: "Deadly and sharp, but requires great effort to swing.",
      description:
        "Not as effective as a purpose built polearm, but the blade has been repositioned for ease of use",
      logName: "Scythe",
    },
    stats: {
      weight: 14,
    },
    attacks: {
      onehanded: {
        strength: 8,
        stamina: 40,
        poise: 30,
        damage: 70,
      },
      twohanded: {
        strength: 4,
        stamina: 40,
        poise: 30,
        damage: 70,
      },
    },
  },
  sledgehammer: {
    ...baseWeapon,
    text: {
      name: "Sledgehammer",
      info: "Crush any enemy in a single blow, if you can swing it.",
      description:
        "Only used in earnest as a show of force, the few that can wield a sledgehammer in combat strike fear in their foes.",
      logName: "Sledgehammer",
    },
    stats: {
      weight: 20,
    },
    attacks: {
      onehanded: {
        strength: 12,
        stamina: 60,
        poise: 60,
        damage: 160,
      },
      twohanded: {
        strength: 6,
        stamina: 60,
        poise: 60,
        damage: 160,
      },
    },
  },
} as const;
